<template>
  <b-modal
    id="bv-modal-create-linked-archives"
    title="Создать архив"
    hide-footer
    centered
  >
    <b-form @submit.prevent="createArchive">
      <b-form-group
        label="Название архива"
        label-for="archive-name"
        label-cols-sm="4"
        label-align-sm="right"
        label-size="sm"
      >
        <b-form-input
          id="archive-name"
          v-model.trim="form.name"
          required
          placeholder="Введите название"
        />
      </b-form-group>

      <b-form-group
        label="Описание"
        label-for="archive-description"
        label-cols-sm="4"
        label-align-sm="right"
        label-size="sm"
      >
        <b-form-textarea
          id="archive-description"
          v-model.trim="form.description"
          rows="3"
          placeholder="Описание архива"
        />
      </b-form-group>

      <div class="text-right mt-4">
        <b-button
          variant="secondary"
          @click="$bvModal.hide('bv-modal-create-linked-archives')"
        >
          Отмена
        </b-button>
        <b-button
          variant="primary"
          class="ml-2"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-1"
          />
          Создать
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'DistanceModalCreateLinkedArchives',
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton, BSpinner,
  },
  props: {
    startId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
      },
      loading: false,
    }
  },
  methods: {
    async createArchive() {
      if (!this.form.name.trim()) {
        this.$bvToast.toast('Введите название архива', {
          title: 'Ошибка',
          variant: 'warning',
          solid: true,
        })
        return
      }

      this.loading = true
      try {
        const payload = {
          name: this.form.name,
          description: this.form.description,
          startIds: [this.startId],
        }

        await this.$http.post('start/start-archive/new-archive', payload)

        this.$bvToast.toast(`Архив "${this.form.name}" успешно создан`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })

        this.$bvModal.hide('bv-modal-create-linked-archives')
        this.form = { name: '', description: '' }

        this.$emit('archive-created')
      } catch (error) {
        console.error('Ошибка при создании архива:', error)
        this.$bvToast.toast('Ошибка при создании архива', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.b-form-group {
  margin-bottom: 1rem;
}

textarea {
  resize: none;
}

.b-button {
  transition: all 0.2s ease;
}

.b-button:hover {
  transform: scale(1.03);
}
</style>
